import { render, staticRenderFns } from "./AdminColourHome.vue?vue&type=template&id=0cdf0995&scoped=true"
import script from "./AdminColourHome.vue?vue&type=script&lang=js"
export * from "./AdminColourHome.vue?vue&type=script&lang=js"
import style0 from "./AdminColourHome.vue?vue&type=style&index=0&id=0cdf0995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf0995",
  null
  
)

export default component.exports